import { INITIAL_REDUX_STATE } from 'vio-constants';
const activityLogsState = {
    activityCrossConnectionLogs: [],
    activityKEXLogs: [],
    activityLocationLogs: [],
    activityLocationNetworkInterfacesLogs: [],
    activityLocationsLogs: [],
    activityNetworkInterfacesLogs: [],
    activityUsersLogs: [],
    crossConnectionLogsPerPage: INITIAL_REDUX_STATE.ACTIVITY_LOGS.CROSS_CONNECTION_LOGS_PER_PAGE,
    kexLogsPerPage: INITIAL_REDUX_STATE.ACTIVITY_LOGS.KEX_LOGS_PER_PAGE,
    locationLogsPerPage: INITIAL_REDUX_STATE.ACTIVITY_LOGS.LOCATION_LOGS_PER_PAGE,
    locationNetworkInterfacesLogsPerPage: INITIAL_REDUX_STATE.ACTIVITY_LOGS.NETWORK_INTERFACES_LOGS_PER_PAGE,
    locationsLogsPerPage: INITIAL_REDUX_STATE.ACTIVITY_LOGS.LOCATIONS_LOGS_PER_PAGE,
    networkInterfacesLogsPerPage: INITIAL_REDUX_STATE.ACTIVITY_LOGS.NETWORK_INTERFACES_LOGS_PER_PAGE,
    page: undefined,
    receiveAllActivityLogs: false,
    requestingActivityCrossConnectionLogs: false,
    requestingActivityKEXLogs: false,
    requestingActivityLocationLogs: false,
    requestingActivityLocationNetworkInterfacesLogs: false,
    requestingActivityLocationsLogs: false,
    requestingActivityNetworkInterfacesLogs: false,
    requestingActivityUsersLogs: false,
    usersLogsPerPage: INITIAL_REDUX_STATE.ACTIVITY_LOGS.USERS_LOGS_PER_PAGE
};
export default activityLogsState;
